import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'formly-field-stepper',
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: { displayDefaultIndicatorType: false }
  }],
  template: `<mat-horizontal-stepper [linear]="true" labelPosition="bottom"   [ngClass]="'last-edited-step-' + selectedIndex"   #stepper  [selectedIndex]="selectedIndex">
    <ng-container *ngFor="let step of field.fieldGroup; let index = index; let last = last">
    <h1>james</h1>
    <mat-step label="{{step?.props?.label}}"  state="{{index+1}}">
      <ng-template matStepperIcon="{{index+1}}" >
        <em class="fa {{step?.props?.icon}}" aria-hidden="true"></em>
       
    </ng-template>
    
    <formly-field [field]="step"></formly-field>
  
      <div class="col-12 text-center mt-3 ">
        <button class="btn btn-cancel"  *ngIf="index !== 0"  type="button" (click)="previous()"> <em class="fa fa-arrow-left"></em> {{'Previous' | translate}}  </button> &nbsp;              
        <button class="btn btnc" type="button" *ngIf="!last" (click)="next(stepper, step.fieldGroup)">{{'next' | translate}} <em class="fa fa-arrow-right"></em>   </button> &nbsp; 
        <!-- <button class="btn btnc" type="button" *ngIf="last" (click)="submit(step.fieldGroup)">{{'submit' | translate}} <em class="fa fa-check-circle"></em>   </button>  -->
         </div>
  </mat-step>
         </ng-container>
  </mat-horizontal-stepper>`,
  styles:[`
:host::ng-deep .mat-step-icon {
    height: 50px !important;
    width: 50px !important;
}

:host::ng-deep .mat-stepper-label-position-bottom .mat-horizontal-stepper-header:not(:last-child)::after ,  

:host::ng-deep .mat-stepper-label-position-bottom .mat-horizontal-stepper-header:not(:first-child)::before {
    border-top-width: 5px !important;
    border-top-style: solid !important;
    border-color: #fa4d2e !important;
    content: "" !important;
    height: 0 !important;
    position: absolute !important;
    top: 44px !important;
    width: calc(50% - 30px) !important;
}

:host::ng-deep .mat-horizontal-stepper-header {
    pointer-events: none !important;
}

:host::ng-deep .mat-stepper-horizontal-line {
  border-top-width: 5px !important;
    border-top-style: solid !important;
    border-color: #fa4d2e !important;
   
    top: 44px !important;
   
}
:host::ng-deep .mat-step-header .mat-step-icon-selected, .mat-step-header .mat-step-icon-state-done, .mat-step-header .mat-step-icon-state-edit {
    background-color:#fa4d2e !important;
    color: #fff; font-size:18px;
  }
  :host::ng-deep .mat-step-header .mat-step-icon-state-done{
    background-color:#fa4d2e !important;
  }
  `],
  standalone:true,
  imports:[
    TranslateModule,MatTabsModule,MatFormFieldModule,CommonModule,FormlyModule,MatTooltipModule,MatIconModule,
    MatStepperModule
  ]
})
export class FormlyFieldStepper extends FieldType {
  selectedIndex=0;
  next(stepper: any, step: any) {
    this.form.markAllAsTouched();

    const areAllControlsValid = step.every((field: any) =>
      field?.formControl ? field.formControl.valid : true
    );

    if (areAllControlsValid) {
      this.form.markAsUntouched();
      stepper.next();
      this.selectedIndex=this.selectedIndex+1
    }
  }
  submit(step:any){
    this.form.markAllAsTouched();
    const areAllControlsValid = step.every((field: any) =>
    field?.formControl ? field.formControl.valid : true
  );

  if (areAllControlsValid) {
    // console.log(this.form.value)
  }
  }
  previous(){
    this.selectedIndex=this.selectedIndex-1
  }
  ngOnInit(){
// console.log('field',this.field.fieldGroup)
  }
}
